import * as React         from 'react';
import { useTranslation } from 'react-i18next';
import DV                 from 'ts-data-validator';

import useRequest           from '../../../../common/services/request';
import { catalogFunctions } from '../../../../components/catalog/functions';

function renderSTBBlock(data, index) {
  return (
    <STBBlock
      key={index}
      data={data}
    />
  );
}

const STBBlock = function(props) {
  const { t } = useTranslation();

  const { data } = props;

  const request = useRequest();

  const timeout = React.useRef(null);

  const [loading, setLoading] = React.useState(true);
  const [stb, setStb]         = React.useState({
    maxStandard:    {},
    minStandard:    {
      coldProtection:  0.30,
      draftProtection: 50,
      security:        400,
      soundInsulation: 25,
    },
    seriesStandard: {},
  });

  const getData = React.useCallback(() => {
    if (DV.isNumber(data.SERIES)) {
      const promise = request.get(`/api/v1/get-stb-standard?series=${data.SERIES}`);

      promise
        .then((response) => {
          const { stb } = response;

          setStb((prev) => ({
            ...prev,
            ...stb,
          }));
          setLoading(false);
        })
        .catch(() => {
        });
    } else {
      if (loading) {
        setLoading(false);
      }
    }
  }, [data.SERIES, loading]);

  React.useEffect(() => {
    if (Object.keys(stb.seriesStandard).length === 0 && Object.keys(stb.maxStandard).length === 0) {
      timeout.current = setTimeout(getData, 100);
    } else if (loading) {
      setLoading(false);
    }

    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);

        timeout.current = null;
      }
    };
  }, []);

  if (Object.keys(stb.seriesStandard).length === 0 || Object.keys(stb.maxStandard).length === 0) {
    return null;
  }

  return (
    <section className={'stb-info'} style={{ backgroundColor: data.BACKGROUND_COLOR }}>
      <div className={'container'}>
        <h2>{t('label_spec_info')}</h2>
        <div className={'graph'}>
          <div>
            <h4>{t('stb_label')}</h4>
            <p>{t('stb_text')}</p>
          </div>
          <div>
            {Object
              .keys(stb.seriesStandard)
              .map((key) => {
                const standard = catalogFunctions.getScore(stb.minStandard, stb.maxStandard, key);
                const current  = catalogFunctions.getScore(stb.minStandard, stb.maxStandard, key, stb.seriesStandard[key]);

                return (
                  <div key={key}>
                    <span className={'title'}>{t(`stb_${key}StandardLabel`)}</span>
                    <div className={'scale'}>
                      <div
                        className={'stb'}
                        style={{ width: `${standard}%` }}
                      />
                      <div
                        className={'current'}
                        style={{ width: `${current}%` }}
                      />
                    </div>
                  </div>
                );
              })
            }
            <div className={'legend'}>
              {' '}<span className={'stb'}>{t('stb_label')}</span>
              {' '}<span className={'current'}>{t('label_our_quality')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default renderSTBBlock;